import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDonationTypes } from "../../apis/actions/donation.actions";
import {
  getAllGeneralDonations,
  getCompletedGeneralDonation,
  getGeneralDonationTypes,
  getHomePageGeneralDonations,
} from "../../apis/actions/generalDonations.actions";
import { AppDispatch, RootState } from "../../apis/store";
import headerBg from "../../assets/background/InternBanner2.png";
import headerMobileBg from "../../assets/images/MVCases.png";
import Loader from "../../biblio/Loader/Loader";
import PaginationComponent from "../../biblio/Pagination/PaginationComponent";
import FooterSection from "../../components/sections/FooterSection";
import NavBar from "../communs/NavBar";
import HeroSectionDetailsProject from "./layout-details-project/HeroSectionDetailsProject";

import SearchWithSelect from "../../biblio/SearchWithSelect";
import CaseList from "../../components/sections/CasesSection/CaseList";
import { scroll } from "../../components/utils/utils";

const itemPerPage = 8;
const GeneralDonations = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    donationTypes,
    completedGeneralDonations,
    generalDonations,
    generalDonationTypes,
    statusGeneralDonation,
  } = useSelector((state: RootState) => state?.generalDonations);

  const currentRef = useRef<HTMLDivElement>(null);

  const [active, setActive] = useState<number>(1);
  const [searchState, setSearchState] = useState<any>({});

  useEffect(() => {
    getGeneralDonations();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  const getGeneralDonations = async () => {
    await dispatch(getHomePageGeneralDonations());
    await dispatch(getAllGeneralDonations());
    await dispatch(getGeneralDonationTypes());
    await dispatch(getDonationTypes());
    await dispatch(getCompletedGeneralDonation());
  };

  useEffect(() => {
    handleToggle();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    donationTypes,
    completedGeneralDonations,
    statusGeneralDonation,
    generalDonations,
    generalDonationTypes,
  ]);

  const handleToggle = (isCompleted: boolean = false) => {
    setSearchState({
      items: isCompleted ? completedGeneralDonations : generalDonations,
      initialItems: isCompleted ? completedGeneralDonations : generalDonations,

      options: [
        ...generalDonationTypes.map((option: any) => ({
          label: option.name,
          value: option.id,
        })),
      ],
      fieldsName: ["summary", "name"],
      typeFieldName: "request_type_id",
      url: "",
      placeholderSelect: "اختر نوع التبرع العام",
      toFilter: false,
      title: " كل التبرعات العامة",
      type: "التبرع العام",
      filteredProjects: generalDonations,
      loading: statusGeneralDonation === "idle",
      titleBtnCompleted: isCompleted ? "تبرعات  تنتظر دعمكم" : "المكتملة",
      isCompleted: isCompleted,
      showIscompletedButton: true,
      types: donationTypes,
    });
  };

  const updateActive = (nb: number) => {
    setActive(nb);
    scroll(currentRef);
  };

  if (statusGeneralDonation === "idle") {
    return (
      <>
        <Loader />
      </>
    );
  }

  return (
    <div className="takaful--projects-container">
      <NavBar variant="projectDetails" />
      <HeroSectionDetailsProject
        title="الرئيسية"
        subTitle="التبرعات العامة"
        urlImage={headerBg}
        mobileImage={headerMobileBg}
        type={"التبرع العام"}
      />
      <section className="takaful--cases-section" style={{ marginTop: "2vh" }}>
        <div className="takaful--cases-header">
          <SearchWithSelect
            state={searchState}
            setFiltredList={(filtred, e) =>
              setSearchState({
                ...searchState,
                filteredProjects: filtred,
                toFilter: e,
              })
            }
            updateIsCompleted={() => handleToggle(!searchState.isCompleted)}
          />
        </div>

        <CaseList
          state={searchState}
          startIndex={itemPerPage * (active - 1)}
          endIndex={itemPerPage * active}
        />
      </section>
      {searchState.filteredProjects &&
        searchState.filteredProjects.length > itemPerPage && (
          <PaginationComponent
            active={active}
            scroll={() => scroll(currentRef)}
            total={searchState.filteredProjects.length}
            itemPerPage={itemPerPage}
            setActive={(nb) => updateActive(nb)}
          />
        )}
      <FooterSection />
    </div>
  );
};

export default GeneralDonations;
